import script from "./ProfitCalculation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfitCalculation.vue?vue&type=script&setup=true&lang=js"

import "./ProfitCalculation.vue?vue&type=style&index=0&id=3b354ed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b354ed4"]])

export default __exports__